import React, {ChangeEvent} from "react";
import {ValidationState} from "../util/ValidationState";
import "./ValidatingTextInput.css";

interface Props {
  value: string;
  onChange: (value: string) => void;
  validationState: ValidationState;
  validationFeedback: string | null;
}

export const ValidatingTextInput = ({
                                      value,
                                      onChange,
                                      validationState,
                                      validationFeedback
                                    }: Props) => {

  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    onChange(ev.target.value);
  };

  let validationIcon = null;
  if (validationState === 'pending') {
    validationIcon = "…";
  } else if (validationState === 'valid') {
    validationIcon = "✓";
  }
  if (validationState === 'invalid') {
    validationIcon = "🗙";
  }

  return (
      <div className={`validating-text-input validation-${validationState}`}>
        <div className="validating-text-input-label-and-input">
          <div className="validation-text-input-and-icon">
            <input className={`validation-text-input-input validation-${validationState}`}
                   type="text"
                   value={value}
                   onChange={handleChange}
            />
            <div className={`validation-icon`}>{validationIcon}</div>
          </div>
        </div>

        {<div className="validation-feedback">
          {validationFeedback ?? <>&nbsp;</>}
        </div>}
      </div>
  );
};